import { EnterprisePortalLayout } from 'shared/ui/portal-layout';
import { AnnexDpa } from './AnnexDpa';

export const AnnexDpaPage = () => {
    return (
        <EnterprisePortalLayout>
            <AnnexDpa />
        </EnterprisePortalLayout>
    );
};
